import { GET } from "./api.http.service";

export const getSearchAPI = (payload) => GET("project/search")(payload);
export const getGenresAPI = (payload) => GET("project/genres")(payload);
export const getCountriesAPI = (payload) => GET("project/countries")(payload);
export const getArtistNamesAPI = (payload) => GET("project/names2")(payload);
export const getArtistDetailAPI = (payload) => GET("album")(payload);
